import { Injectable, Signal, computed } from '@angular/core';
import { Store } from '@ngxs/store';
import { Translation } from '../models/translation';
import { MainState } from '../stores/main.store';

@Injectable({ providedIn: 'root' })
export class TranslationService {
  translations: Signal<Translation[]>;

  constructor(private store: Store) {
    this.translations = this.store.selectSignal(MainState.translations);
  }

  getTranslationSignal(key: string, args?: Record<string, any>): Signal<string> {
    return computed(() => {
      const translatedValue = this.translations().filter((x) => x.key?.toUpperCase() == key?.toUpperCase())[0]?.value ?? key;
      return this.interpolate(translatedValue, args);
    });
  }

  getTranslation(key: string, args?: Record<string, any>): string {
    if (!key || key.length === 0) {
      return '';
    }
    return this.getTranslationSignal(key, args)();
  }

  private interpolate(text: string, args?: Record<string, any>): string {
    if (!args) {
      return text;
    }
    return text.replace(/\{(\w+)\}/g, (match, placeholder) => {
      return args[placeholder] !== undefined ? String(args[placeholder]) : match;
    });
  }
}
